module.exports = __webpack_public_path__ + "img/transaction.abfd0897.svg";